// extracted by mini-css-extract-plugin
module.exports = {"productcontent":"__60w-solar-panel_productcontent__0yNNs"};